import React, { useState, useEffect, useCallback, useRef } from 'react';
import { FiPlus, FiEdit3, FiTrash2, FiStar, FiCheck, FiX } from 'react-icons/fi';
import {
  listarPerfisNf, criarPerfilNf, atualizarPerfilNf, excluirPerfilNf,
} from '../../services/nfPerfis';
import SeletorMunicipio from '../../componentes/SeletorMunicipio';
import SeletorCodigoFiscal from '../../componentes/SeletorCodigoFiscal';
import styles from './Clientes.module.css';
import CampoCodigoMunicipal from '../nf/CampoCodigoMunicipal';
import CampoMoeda from '../../componentes/CampoMoeda';

/* Perfis de tributação do cliente: cada um guarda os códigos fixos de um
   tipo de serviço, pra emissão não exigir redigitar tudo. Quem tem um só
   perfil não precisa escolher nada na hora de emitir -- ele vem marcado
   como padrão automaticamente (regra no backend). */

const TRIBUTACAO_ISSQN = [
  { valor: 1, label: 'Operação tributável' },
  { valor: 2, label: 'Exportação de serviço' },
  { valor: 3, label: 'Não incidência' },
  { valor: 4, label: 'Imunidade' },
];

const VAZIO = {
  nome: '', codigo_tributacao_nacional: '', codigo_tributacao_municipal: '', item_nbs: '', codigo_operacao: '',
  descricao_servico: '', codigo_municipio_prestacao: '', valor_padrao: '',
  aliquota_iss: '', tributacao_issqn: 1, reter_iss: false, padrao: false,
  ret_irrf: '', ret_inss: '', ret_pis: '', ret_cofins: '', ret_csll: '',
  dados_pagamento: '', vencimento_tipo: '', vencimento_valor: '', texto_complementar: '',
};

/* retenções federais: % sobre o valor do serviço (a nota calcula o R$) */
const RETENCOES = [
  { campo: 'ret_irrf', rotulo: 'IRRF (%)', dica: 'ex.: 1,5' },
  { campo: 'ret_inss', rotulo: 'INSS (%)', dica: 'ex.: 11' },
  { campo: 'ret_pis', rotulo: 'PIS (%)', dica: 'ex.: 0,65' },
  { campo: 'ret_cofins', rotulo: 'COFINS (%)', dica: 'ex.: 3' },
  { campo: 'ret_csll', rotulo: 'CSLL (%)', dica: 'ex.: 1' },
];

function FormPerfil({ clienteId, inicial, onCancelar, onSalvar, salvando, onRascunho }) {
  const [f, setF] = useState({ ...VAZIO, ...inicial });
  const set = (c, v) => setF(p => ({ ...p, [c]: v }));
  useEffect(() => { if (onRascunho) onRascunho(f); }, [f, onRascunho]);

  return (
    <div className={styles.dadosSecao} style={{ background: '#fafcff', borderRadius: 10, padding: 12 }}>
      <div className={styles.dadosGrid}>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Nome do perfil *</span>
          <input className={styles.dadosInput} value={f.nome} autoFocus
            placeholder="Ex.: Consultoria, Manutenção..."
            onChange={e => set('nome', e.target.value)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Código Tributação Nacional (CTN)</span>
          <SeletorCodigoFiscal tabela="ctn" className={styles.dadosInput}
            valor={f.codigo_tributacao_nacional || ''}
            onChange={v => set('codigo_tributacao_nacional', v)}
            placeholder="Código ou descrição do serviço (LC 116)" />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Código complementar municipal</span>
          <CampoCodigoMunicipal clienteId={clienteId} className={styles.dadosInput}
            ctn={f.codigo_tributacao_nacional} municipio={f.codigo_municipio_prestacao}
            valor={f.codigo_tributacao_municipal || ''} onChange={v => set('codigo_tributacao_municipal', v)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Código NBS *</span>
          <SeletorCodigoFiscal tabela="nbs" className={styles.dadosInput}
            valor={f.item_nbs || ''}
            onChange={v => set('item_nbs', v)}
            placeholder="Código ou descrição (obrigatório na nota)" />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Código indicador da operação</span>
          <input className={styles.dadosInput} value={f.codigo_operacao || ''}
            placeholder="IBS/CBS" onChange={e => set('codigo_operacao', e.target.value)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Município de prestação</span>
          <SeletorMunicipio className={styles.dadosInput} valor={f.codigo_municipio_prestacao || ''}
            onChange={v => set('codigo_municipio_prestacao', v)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Valor do serviço (R$) — fixo, se for sempre o mesmo</span>
          <CampoMoeda className={styles.dadosInput} value={f.valor_padrao ?? ''}
            onChange={v => set('valor_padrao', v)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Alíquota ISS (%) — no Simples vale a do mês</span>
          <input className={styles.dadosInput} type="number" step="0.01" value={f.aliquota_iss ?? ''}
            onChange={e => set('aliquota_iss', e.target.value)} />
        </div>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Tributação do ISSQN</span>
          <select className={styles.dadosInput} value={f.tributacao_issqn}
            onChange={e => set('tributacao_issqn', Number(e.target.value))}>
            {TRIBUTACAO_ISSQN.map(o => <option key={o.valor} value={o.valor}>{o.label}</option>)}
          </select>
        </div>
      </div>

      <div className={styles.dadosCampo} style={{ marginTop: 10 }}>
        <span className={styles.dadosLabel}>Descrição do serviço</span>
        <textarea className={styles.dadosInput} rows={2} value={f.descricao_servico || ''}
          onChange={e => set('descricao_servico', e.target.value)} />
      </div>

      <p className={styles.dadosSecaoTitulo} style={{ marginTop: 14 }}>Retenções na fonte</p>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer', marginBottom: 8 }}>
        <input type="checkbox" checked={!!f.reter_iss} onChange={e => set('reter_iss', e.target.checked)} />
        ISS retido pelo tomador
      </label>
      <div className={styles.dadosGrid}>
        {RETENCOES.map(r => (
          <div key={r.campo} className={styles.dadosCampo}>
            <span className={styles.dadosLabel}>{r.rotulo}</span>
            <input className={styles.dadosInput} type="number" step="0.01" min="0" value={f[r.campo] ?? ''} placeholder={r.dica}
              onChange={e => set(r.campo, e.target.value)} />
          </div>
        ))}
      </div>

      <p className={styles.dadosSecaoTitulo} style={{ marginTop: 14 }}>Vencimento padrão (o do tomador, se houver, vale primeiro)</p>
      <div className={styles.dadosGrid}>
        <div className={styles.dadosCampo}>
          <span className={styles.dadosLabel}>Vencimento</span>
          <select className={styles.dadosInput} value={f.vencimento_tipo || ''} onChange={e => set('vencimento_tipo', e.target.value)}>
            <option value="">Não informar</option>
<option value="dia_fixo_mes">Dia fixo no mês da nota</option>
            <option value="dia_fixo">Dia fixo no mês seguinte</option>
            <option value="informar">Informar a data completa na emissão</option>
            <option value="dias_apos">Dias após a emissão</option>
          </select>
        </div>
        {f.vencimento_tipo && f.vencimento_tipo !== 'informar' && (
          <div className={styles.dadosCampo}>
            <span className={styles.dadosLabel}>{f.vencimento_tipo.startsWith('dia_fixo') ? 'Dia do mês (fim de semana antecipa)' : 'Quantos dias'}</span>
            <input className={styles.dadosInput} type="number" min="1" max={f.vencimento_tipo.startsWith('dia_fixo') ? 31 : 365}
              value={f.vencimento_valor ?? ''} onChange={e => set('vencimento_valor', e.target.value)} />
          </div>
        )}
      </div>
      <div className={styles.dadosCampo} style={{ marginTop: 8 }}>
        <span className={styles.dadosLabel}>Texto fixo do corpo da nota</span>
        <textarea className={styles.dadosInput} rows={2} value={f.texto_complementar || ''}
          placeholder="Ex.: Contrato nº 123/2026 · Serviço referente ao mês de competência"
          onChange={e => set('texto_complementar', e.target.value)} />
      </div>

      <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: 10 }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
          <input type="checkbox" checked={!!f.padrao} onChange={e => set('padrao', e.target.checked)} />
          Usar como perfil padrão
        </label>
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button type="button" className={styles.drawerBtnAcao}
          onClick={() => onSalvar(f)} disabled={salvando || !f.nome.trim()}>
          <FiCheck size={13} /> {salvando ? 'Salvando...' : 'Salvar perfil'}
        </button>
        <button type="button" className={`${styles.drawerBtnAcao} ${styles.drawerBtnAcaoGhost}`}
          onClick={onCancelar}>
          <FiX size={13} /> Cancelar
        </button>
      </div>
    </div>
  );
}

/* editarInicial: id do perfil (ou 'novo') pra já abrir no formulário -- é
   como a revisão da emissão traz a pessoa direto no campo que falta.
   onSalvo: chamado depois de gravar (a emissão usa pra voltar sozinha). */
/* pendente: ref do modal de Parâmetros -- com um perfil aberto, guarda a
   função que grava esse perfil. Era aqui que o NBS se perdia: a pessoa
   preenchia o perfil e clicava em "Salvar parâmetros" lá embaixo, que só
   gravava o cliente. */
function PerfisTributacaoNf({ clienteId, semTitulo, editarInicial, onSalvo, pendente }) {
  const [perfis, setPerfis] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState('');
  const [editando, setEditando] = useState(null); // objeto do perfil, ou {} pra novo
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(() => {
    setCarregando(true);
    return listarPerfisNf(clienteId)
      .then(r => setPerfis(r.items || []))
      .catch(e => setErro(e.message))
      .finally(() => setCarregando(false));
  }, [clienteId]);
  useEffect(() => { carregar(); }, [carregar]);

  const [inicialAplicado, setInicialAplicado] = useState(false);
  useEffect(() => {
    if (!editarInicial || inicialAplicado || carregando) return;
    setInicialAplicado(true);
    setEditando(perfis.find(p => p.id === editarInicial) || {});
  }, [editarInicial, inicialAplicado, carregando, perfis]);

  const rascunho = useRef(null);
  const guardarRascunho = useCallback((f) => { rascunho.current = f; }, []);

  async function salvar(dados) {
    if (!dados?.nome?.trim()) { setErro('Dê um nome ao perfil antes de salvar.'); return false; }
    setSalvando(true); setErro('');
    try {
      if (editando?.id) await atualizarPerfilNf(clienteId, editando.id, dados);
      else await criarPerfilNf(clienteId, dados);
      setEditando(null);
      rascunho.current = null;
      await carregar();
      if (onSalvo) onSalvo();
      return true;
    } catch (e) { setErro(e.message); return false; }
    finally { setSalvando(false); }
  }

  useEffect(() => {
    if (!pendente) return undefined;
    pendente.current = editando ? () => salvar(rascunho.current) : null;
    return () => { pendente.current = null; };
  });

  async function excluir(p) {
    if (!window.confirm(`Excluir o perfil "${p.nome}"?`)) return;
    try { await excluirPerfilNf(clienteId, p.id); await carregar(); }
    catch (e) { setErro(e.message); }
  }

  return (
    <div className={semTitulo ? undefined : styles.dadosSecao}>
      {!semTitulo && <p className={styles.dadosSecaoTitulo}>Perfis de tributação</p>}
      <p className={styles.dadosAviso} style={{ marginBottom: 10 }}>
        Cada perfil guarda os códigos de um tipo de serviço (CTN, NBS, operação, município).
        Na emissão, basta escolher o perfil que tudo vem preenchido — e continua editável.
        Com um único perfil, ele já vem selecionado.
      </p>

      {erro && <p className={styles.dadosAviso} style={{ color: '#b91c1c' }}>{erro}</p>}

      {carregando ? (
        <p className={styles.dadosAviso}>Carregando...</p>
      ) : (
        <>
          {perfis.length === 0 && !editando && (
            <p className={styles.dadosAviso}>Nenhum perfil cadastrado ainda.</p>
          )}

          {perfis.map(p => (
            <div key={p.id} style={{
              display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px',
              border: '1px solid #e4eef8', borderRadius: 8, marginBottom: 6,
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
                  {p.padrao && <FiStar size={12} color="#f59e0b" title="Perfil padrão" />}
                  {p.nome}
                </div>
                <div style={{ fontSize: 11.5, color: '#6b8cae', marginTop: 2 }}>
                  {[p.codigo_tributacao_nacional && `CTN ${p.codigo_tributacao_nacional}${p.codigo_tributacao_municipal ? `.${p.codigo_tributacao_municipal}` : ''}`,
                    p.item_nbs && `NBS ${p.item_nbs}`,
                    p.aliquota_iss != null && `ISS ${p.aliquota_iss}%`,
                    p.reter_iss && 'retém ISS',
                  ].filter(Boolean).join(' · ') || 'sem códigos definidos'}
                </div>
              </div>
              <button type="button" className={styles.btnAcessoEdit} title="Editar"
                onClick={() => setEditando(p)}><FiEdit3 size={13} /></button>
              <button type="button" className={styles.btnAcessoEdit} title="Excluir"
                onClick={() => excluir(p)}><FiTrash2 size={13} /></button>
            </div>
          ))}

          {editando ? (
            <FormPerfil clienteId={clienteId}
              inicial={editando}
              salvando={salvando}
              onCancelar={() => setEditando(null)}
              onSalvar={salvar}
              onRascunho={guardarRascunho}
            />
          ) : (
            <button type="button" className={styles.drawerBtnAcao} style={{ marginTop: 6 }}
              onClick={() => setEditando({})}>
              <FiPlus size={13} /> Novo perfil
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default PerfisTributacaoNf;
